import React, { Component } from 'react'
import OutreachCard from './OutreachCard'
import OutreachGrid from './OutreachGrid'
import OutreachHeader from './OutreachHeader'
import Pagination from './Pagination'

import eventsConfig from '../../configs/events-config'

class Outreach extends Component {
  constructor(props) {
    super(props)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)

    this.state = {
      activePage: 1,
      data: [],
      filter: 'all',
      perPage: 12
    }
  }

  handleFilterChange(filter) {
    if (filter === this.state.filter) {
      this.setState({filter: 'all'})
    } else {
      this.setState({filter: filter})
    }
  }

  handlePageChange(pageNumber) {
    this.setState({activePage: pageNumber});
  }

  render () {
    const { activePage, filter, perPage } = this.state
    const { browser } = this.props
    const events = Object.keys(eventsConfig).filter((key) => {
      const event = eventsConfig[key]
      if (filter === 'all') {
        return event
      } else {
        return event.filter === filter
      }
    })

    const cards = events.map((key, index) => {
      const event = eventsConfig[key]
      const url = event.key

      return (
          <OutreachCard
            event={event}
            key={url}
          />
      )
    })

    const totalCount = cards.length
    const { lessThan } = browser
    const { small, medium, large } = lessThan
    let columnCount

    if (small) {
      columnCount = 1
    } else if (medium) {
      columnCount = 2
    } else if (large) {
      columnCount = 2
    } else {
      columnCount = 4
    }

    const headerCard = cards[0]
  
    return (
      <div className="outreach-page">
        <OutreachHeader
          filter={filter}
          headerCard={headerCard}
          onChange={this.handleFilterChange}
        />
          <OutreachGrid
            activePage={activePage}
            cards={cards}
            className="outreach-grid-items"
            columnCount={columnCount}
            perPage={perPage}
          />
          {cards.length > perPage ?
          <Pagination
            activeClass="active"
            activePage={activePage}
            itemsCountPerPage={perPage} 
            onChange={this.handlePageChange}
            totalCount={totalCount} 
          /> : null

          }
      </div>
    )
  }
}

export default Outreach



// WEBPACK FOOTER //
// ./src/components/Outreach/Outreach.js